import React, { useState } from "react";
import {
  alpha,
  Menu,
  MenuItem,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Box, Stack } from "@mui/system";
import FilterListIcon from "@mui/icons-material/FilterList";
import PropTypes from "prop-types";

const CustomBox = styled(Box)(({ theme }) => ({
  padding: "8px 16px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "12px",
  width: "200px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.background.paper, 0.8)
      : alpha(theme.palette.primary.main, 0.05),
    transform: "translateY(-2px)",
    boxShadow: theme.palette.mode === 'dark'
      ? `0px 4px 12px ${alpha(theme.palette.common.black, 0.3)}`
      : `0px 4px 12px ${alpha(theme.palette.primary.main, 0.15)}`,
  },
  [theme.breakpoints.down("md")]: {
    width: "auto",
    borderRadius: "50%",
    padding: "8px",
  },
}));

const FilterSelect = (props) => {
  const { setType } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState("all");
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (selectedItem) => {
    setValue(selectedItem);
    setType(selectedItem);
    setAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <CustomBox onClick={handleClick}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <FilterListIcon sx={{ color: "text.secondary" }} />
          {!isSmall && (
            <>
              <Typography color="text.secondary">{t("Filter By")}</Typography>:
              <Typography textTransform="capitalize" color="text.primary" fontWeight={500}>
                {t(value)}
              </Typography>
            </>
          )}
        </Stack>
      </CustomBox>
      <Menu
        disableScrollLock={true}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => handleClose("all")}>{t("All")}</MenuItem>
        <MenuItem onClick={() => handleClose("delivery")}>
          {t("Delivery")}
        </MenuItem>
        <MenuItem onClick={() => handleClose("take away")}>
          {t("Take Away")}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default FilterSelect;
